import React, { Component } from 'react';
import { Modal, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment'
import md5 from 'js-md5'
import uuidv4 from 'uuid/v4'
import auth from '../../../utils/auth'
import alertMessage from '../../../utils/alertMessage';
class FormImport extends Component {
  beforeUpload = (file, FileList) => {
    return true
  }
  getHeader = () => {
    const authInfo = auth.getAuthInfo()
    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
    const uuid = uuidv4()
    const nounce = md5(timestamp + uuid)

    return {
      timestamp,
      uuid,
      nounce,
      Authorization: `Bearer ${authInfo.token}`,
    }
  }

  onChange = (info) => {
    const { handleCancel } = this.props
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      if (info.file.response.code !== 0) {
        alertMessage.error('Import Failed！'+ info.file.response.messageEn)
      } else {
        handleCancel()
        alertMessage.success('Import Success！')
      }
    } else if (info.file.status === 'error') {
      alertMessage.error('Import Failed！')
    }
  }
  render() {
    const {modalVisible,handleCancel} = this.props
    const { Dragger } = Upload
    const UPLOAD_TEMPLATE_URL = `${window.g.apiBaseUrl}/config/transportation/import`

    return (
      <>
        <Modal
          title='Import'
          // closable={false}
          visible={modalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={null}
        >
          <Dragger
            action={UPLOAD_TEMPLATE_URL}
            headers={this.getHeader()}
            style={{ width: '100%', margin: '0 auto' }}
            onChange={this.onChange}
            data={{
              importDate: moment(new Date()),
            }}
            beforeUpload={this.beforeUpload}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined style={{color: 'rgb(154,219,231)'}} />
            </p>
            <p className="ant-upload-text">Click or drag the file here</p>
          </Dragger>
        </Modal>
      </>
    );
  }
}

export default FormImport;
